/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CalendarFeedOut,
  CalendarOut,
  GetCalendarParams,
  HTTPValidationError
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getCalendarResponse200 = {
  data: CalendarOut
  status: 200
}

export type getCalendarResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getCalendarResponseSuccess = (getCalendarResponse200) & {
  headers: Headers;
};
export type getCalendarResponseError = (getCalendarResponse422) & {
  headers: Headers;
};

export type getCalendarResponse = (getCalendarResponseSuccess | getCalendarResponseError)

export const getGetCalendarUrl = (params: GetCalendarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/calendar?${stringifiedParams}` : `/api/calendar`
}

/**
 * @summary Get Calendar
 */
export const getCalendar = async (params: GetCalendarParams, options?: Parameters<typeof apiFetch>[1]): Promise<getCalendarResponse> => {

  return apiFetch<getCalendarResponse>(getGetCalendarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCalendarQueryKey = (params?: GetCalendarParams,) => {
    return [
    `/api/calendar`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCalendarQueryOptions = <TData = Awaited<ReturnType<typeof getCalendar>>, TError = HTTPValidationError>(params: GetCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendar>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCalendarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCalendar>>> = ({ signal }) => getCalendar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCalendar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCalendarQueryResult = NonNullable<Awaited<ReturnType<typeof getCalendar>>>
export type GetCalendarQueryError = HTTPValidationError


export function useGetCalendar<TData = Awaited<ReturnType<typeof getCalendar>>, TError = HTTPValidationError>(
 params: GetCalendarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalendar>>,
          TError,
          Awaited<ReturnType<typeof getCalendar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCalendar<TData = Awaited<ReturnType<typeof getCalendar>>, TError = HTTPValidationError>(
 params: GetCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalendar>>,
          TError,
          Awaited<ReturnType<typeof getCalendar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCalendar<TData = Awaited<ReturnType<typeof getCalendar>>, TError = HTTPValidationError>(
 params: GetCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendar>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Calendar
 */

export function useGetCalendar<TData = Awaited<ReturnType<typeof getCalendar>>, TError = HTTPValidationError>(
 params: GetCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendar>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCalendarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createCalendarFeedResponse200 = {
  data: CalendarFeedOut
  status: 200
}

export type createCalendarFeedResponseSuccess = (createCalendarFeedResponse200) & {
  headers: Headers;
};
;

export type createCalendarFeedResponse = (createCalendarFeedResponseSuccess)

export const getCreateCalendarFeedUrl = () => {




  return `/api/calendar/feed`
}

/**
 * @summary Create Calendar Feed
 */
export const createCalendarFeed = async ( options?: Parameters<typeof apiFetch>[1]): Promise<createCalendarFeedResponse> => {

  return apiFetch<createCalendarFeedResponse>(getCreateCalendarFeedUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCreateCalendarFeedMutationKey = () => ['createCalendarFeed'] as const;

export const getCreateCalendarFeedMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCalendarFeed>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCalendarFeed>>, TError,void, TContext> => {

const mutationKey = getCreateCalendarFeedMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCalendarFeed>>, void> = () => {


          return  createCalendarFeed(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCalendarFeedMutationResult = NonNullable<Awaited<ReturnType<typeof createCalendarFeed>>>

    export type CreateCalendarFeedMutationError = unknown


    /**
 * @summary Create Calendar Feed
 */
export const useCreateCalendarFeed = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCalendarFeed>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCalendarFeed>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateCalendarFeedMutationOptions(options), queryClient);
    }
    export type revokeCalendarFeedResponse204 = {
  data: void
  status: 204
}

export type revokeCalendarFeedResponseSuccess = (revokeCalendarFeedResponse204) & {
  headers: Headers;
};
;

export type revokeCalendarFeedResponse = (revokeCalendarFeedResponseSuccess)

export const getRevokeCalendarFeedUrl = () => {




  return `/api/calendar/feed`
}

/**
 * @summary Revoke Calendar Feed
 */
export const revokeCalendarFeed = async ( options?: Parameters<typeof apiFetch>[1]): Promise<revokeCalendarFeedResponse> => {

  return apiFetch<revokeCalendarFeedResponse>(getRevokeCalendarFeedUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRevokeCalendarFeedMutationKey = () => ['revokeCalendarFeed'] as const;

export const getRevokeCalendarFeedMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeCalendarFeed>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeCalendarFeed>>, TError,void, TContext> => {

const mutationKey = getRevokeCalendarFeedMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeCalendarFeed>>, void> = () => {


          return  revokeCalendarFeed(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeCalendarFeedMutationResult = NonNullable<Awaited<ReturnType<typeof revokeCalendarFeed>>>

    export type RevokeCalendarFeedMutationError = unknown


    /**
 * @summary Revoke Calendar Feed
 */
export const useRevokeCalendarFeed = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeCalendarFeed>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeCalendarFeed>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRevokeCalendarFeedMutationOptions(options), queryClient);
    }
